<template>
    <span v-if="presentation" class="inline-flex items-center" role="img"
          :aria-label="'Загальне враження: ' + presentation.label"
          :title="presentation.label" :class="presentation.color" :style="iconStyle">
        <i :class="presentation.icon" aria-hidden="true"></i>
    </span>
</template>

<script>
export default {
    name: 'OpinionTypeIcon',
    props: {
        mood: { type: String, default: null },
        // Accepted for old callers only; legacy opinion never establishes mood.
        opinionType: {
            type: String,
            default: null,
            validator: (value) => !value || ['positive', 'neutral', 'negative'].includes(value)
        },
        size: {
            type: String,
            default: 'md', // 'sm', 'md', 'lg'
            validator: (value) => ['sm', 'md', 'lg'].includes(value)
        }
    },
    computed: {
        presentation() {
            const moods = {
                positive: { label: 'Позитивне', icon: 'fas fa-smile', color: 'text-green-600 dark:text-green-400' },
                mixed: { label: 'Змішане', icon: 'fas fa-meh', color: 'text-yellow-600 dark:text-yellow-400' },
                negative: { label: 'Негативне', icon: 'fas fa-frown', color: 'text-red-600 dark:text-red-400' },
            };
            return Object.prototype.hasOwnProperty.call(moods, this.mood) ? moods[this.mood] : null;
        },
        iconStyle() {
            const sizes = {
                sm: { padding: '2px 6px', borderRadius: '6px', width: '24px', height: '24px', fontSize: '0.875rem' },
                md: { padding: '4px 8px', borderRadius: '8px', width: '32px', height: '32px', fontSize: '1rem' },
                lg: { padding: '6px 10px', borderRadius: '10px', width: '40px', height: '40px', fontSize: '1.25rem' }
            };
            return sizes[this.size];
        }
    }
}
</script>

<style scoped>
</style>

